import {
	CLOSE_CANCEL_CONFIRM_MODAL,
	CLOSE_EXIT_CONFIRM_MODAL,
	OPEN_CANCEL_CONFIRM_MODAL,
	OPEN_EXIT_CONFIRM_MODAL,
	SET_SALESPERSON_ID,
	DESTROY_SALESPERSON_ID,
	SET_APPLICATION_FORM_DATA,
	DESTROY_APPLICATION_FORM_DATA,
} from './constants';

export const closeCancelConfirmModal = () => ({ type: CLOSE_CANCEL_CONFIRM_MODAL });

export const closeExitConfirmModal = () => ({ type: CLOSE_EXIT_CONFIRM_MODAL });

export const openCancelConfirmModal = () => ({ type: OPEN_CANCEL_CONFIRM_MODAL });

export const openExitConfirmModal = () => ({ type: OPEN_EXIT_CONFIRM_MODAL });

export const setSalespersonId = id => ({ type: SET_SALESPERSON_ID, id });

export const destroySalespersonId = () => ({ type: DESTROY_SALESPERSON_ID });

export const setApplicationFormData = formValues => ({
	type: SET_APPLICATION_FORM_DATA,
	formValues,
});

export const destroyApplicationFormData = () => ({ type: DESTROY_APPLICATION_FORM_DATA });
